const HISTORY_BASE_INDEX_KEY = "spa_history_base_idx";

export function readHistoryIndex() {
    const historyIndex = window.history.state?.idx;
    return typeof historyIndex === "number" ? historyIndex : 0;
}

export function readBaseHistoryIndex() {
    try {
        const storedValue = window.sessionStorage.getItem(HISTORY_BASE_INDEX_KEY);
        if (storedValue !== null) {
            const parsedValue = Number(storedValue);
            if (Number.isFinite(parsedValue)) {
                return parsedValue;
            }
        }

        const initialIndex = readHistoryIndex();
        window.sessionStorage.setItem(HISTORY_BASE_INDEX_KEY, String(initialIndex));
        return initialIndex;
    } catch {
        return readHistoryIndex();
    }
}

export function canGoBackInsideApp() {
    return readHistoryIndex() > readBaseHistoryIndex();
}
